import type { AiContentPreviewArea } from "./ai-content-feedback.types";

export const AI_CONTENT_PREVIEW_AREA_OPTIONS: {
  id: AiContentPreviewArea;
  label: string;
}[] = [
  { id: "overall_content", label: "Overall content" },
  { id: "subject", label: "Subject" },
  { id: "preheader", label: "Preheader" },
  { id: "headline", label: "Headline" },
  { id: "body_copy", label: "Body copy" },
  { id: "call_to_action", label: "Call to action" },
];
